__turbopack_context__.v({
  "ideeri-secondary": "radio-module__cD6mwW__ideeri-secondary",
  "label": "radio-module__cD6mwW__label",
  "radio": "radio-module__cD6mwW__radio",
  "secondary": "radio-module__cD6mwW__secondary",
});
